import { ChangeDetectorRef, Component, inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser, Location } from '@angular/common';
import { AuthService, OccConfig } from '@spartacus/core';
import { KbCompareService } from 'src/app/services/feature/kb-compare/kb-compare.service';
import { CookieService } from 'src/app/customServices/cookie.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-kb-compare',
  templateUrl: './kb-compare.component.html',
  styleUrls: ['./kb-compare.component.scss'],
  standalone: false
})
export class KbCompareComponent {
  showContent: boolean = false;
  isLoggedIn: boolean = false;
  prodData: any[] = [];
  products: any;
  unTyped: any;
  apiCallProductCode: any[] = [];
  baseUrl: string = this.config?.backend?.occ?.baseUrl + '/';
  dataInSession: boolean;
  isMobile: boolean = false;
  //  TO HIDE THE LABELS
  salesStatusText: boolean = false;
  typenumber: boolean = false;
  name: boolean = false;
  code: boolean = false;
  grossWeight: boolean = false;
  weightUnit: boolean = false;
  showDifferencesOnly: boolean = false;
  private unsubscribe$ = new Subject<void>();
  platformId = inject(PLATFORM_ID);

  constructor(
    public compareProdService: KbCompareService,
    private AuthService: AuthService,
    private location: Location,
    private cdr: ChangeDetectorRef,
    private Session: CookieService,
    private breakpointObserver: BreakpointObserver,
    private config: OccConfig,
    private router: Router,
    private activatedroute: ActivatedRoute
  ) {
    this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small]).pipe(takeUntil(this.unsubscribe$)).subscribe((result) => {
      this.isMobile = result.matches;
    });
    this.AuthService.isUserLoggedIn().pipe(takeUntil(this.unsubscribe$)).subscribe((data) => {
      this.isLoggedIn = data;
    });
  }

  ngOnInit() {
    this.compareProdService.canOpen(false);
    this.activatedroute.queryParamMap.pipe(takeUntil(this.unsubscribe$)).subscribe((params: any) => {
      if (params.get('productCode')) {
        this.Session.setItemSessionStorage('prdCodes', params.get('productCode'));
      }
    });
    this.makeApiCall();

    this.setCustomWidth();
  }
  makeApiCall() {

    const result = this.Session.getItemSessionStorage('prdCodes');
    if (result !== null) {
      this.showContent = false;
      this.compareProdService.getCompareProdsApiCall(result).pipe(takeUntil(this.unsubscribe$)).subscribe((response: any) => {
        this.products = response?.productDataList;
        this.compareProdService.putNewArrayFromApi(this.products);
        this.unTyped = response?.untypedFeaturesMap;
        ['salesStatusText', 'typenumber', 'name', 'code', 'grossWeight', 'weightUnit'].forEach((item) => {
          this[item] = this.products.some((prod) => prod?.[item]);
        });
        this.router.navigate([], {
          queryParams: {
            productCode: result,
          },
          queryParamsHandling: 'merge',
        });
        this.cdr.detectChanges();
      });
    } else {
      this.showContent = true;
    }
  }
  removeProd(prodCode: any) {
    this.compareProdService.compareData = this.compareProdService.compareData.filter((item) => item.code !== prodCode);
    this.products.length = 0;
    this.compareProdService.storeDataToMakeApiCall();
    this.makeApiCall();
  }
  goBack(): void {
    this.location.back();
  }
  setCustomWidth() {
    if (isPlatformBrowser(this.platformId)) {
      const widthInPixels = window.innerWidth;
      document.documentElement.style.setProperty('--custom-CompareTable-width', `${widthInPixels}px`);
    }
  }


  toggleShowDifferences() {
    this.showDifferencesOnly = !this.showDifferencesOnly;
  }
  hasDifferences(product: any, referenceProduct: any): boolean {
    return product?.salesStatusText !== referenceProduct?.salesStatusText ||
      product?.marketType !== referenceProduct?.marketType ||
      product?.grossWeight !== referenceProduct?.grossWeight ||
      product?.weightUnit !== referenceProduct?.weightUnit ||
      (product?.corePrice?.formattedValue !== referenceProduct?.corePrice?.formattedValue ||
        product?.corePrice?.currencyIso !== referenceProduct?.corePrice?.currencyIso) ||
      (product?.listPrice?.formattedValue !== referenceProduct?.listPrice?.formattedValue ||
        product?.listPrice?.currencyIso !== referenceProduct?.listPrice?.currencyIso) ||
      (product?.priceOnRequestText !== referenceProduct?.priceOnRequestText);
  }

  anyDifferences(property: string): boolean {
    if (!this.products || this.products.length === 0) {
      return false;
    }
    const referenceProduct = this.products[0];

    return this.products.some(product => {
      if (property === 'listPrice') {
        return (product?.listPrice?.formattedValue !== referenceProduct?.listPrice?.formattedValue ||
          product?.listPrice?.currencyIso !== referenceProduct?.listPrice?.currencyIso) ||
          (product?.priceOnRequestText !== referenceProduct?.priceOnRequestText);
      }
      if (property === 'corePrice') {
        return (product?.corePrice?.formattedValue !== referenceProduct?.corePrice?.formattedValue ||
          product?.corePrice?.currencyIso !== referenceProduct?.corePrice?.currencyIso) ||
          (product?.priceOnRequestText !== referenceProduct?.priceOnRequestText);
      }
      return product[property] !== referenceProduct[property];
    });
  }
  anyUntypedDifferences(untypedFeatures: any): boolean {
    if (!this.unTyped || this.unTyped.length === 0) {
      return false;
    }

    // Use the first value as the reference
    const referenceValue = untypedFeatures.value[0];

    const hasDifferences = untypedFeatures.value.some((value: any, index: number) => {
      const isDifferent =
        value !== referenceValue || (value === '' && referenceValue !== '') || (value !== '' && referenceValue === '');
      ;
      return isDifferent;
    });

    return hasDifferences;
  }

  shouldShowUntypedUl(untypedFeatures: any): boolean {
    return !this.showDifferencesOnly || this.anyUntypedDifferences(untypedFeatures);
  }

  shouldShowUl(property: string): boolean {
    return !this.showDifferencesOnly || this.anyDifferences(property);
  }

  ngOnDestroy() {
    this.compareProdService.canOpen(true);
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
